import { render, staticRenderFns } from "./BasicDrawer.vue?vue&type=template&id=47185fa4&"
import script from "./BasicDrawer.vue?vue&type=script&lang=js&"
export * from "./BasicDrawer.vue?vue&type=script&lang=js&"
import style0 from "./BasicDrawer.vue?vue&type=style&index=0&id=47185fa4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports